import { ParkingTicketEntry, ParkingTicketsStateModel } from './models';

export const getParkingTickets = (state: ParkingTicketsStateModel): ParkingTicketEntry[] => {
  return state.parkingTickets;
};

export const getIsLoading = (state: ParkingTicketsStateModel): boolean => {
  return state.isLoading;
};
